// Module
var code = `<div class="hc-item"
  ng-repeat="(listName, checkList) in \$ctrl.checks"
  ng-class="[\$ctrl.statuses[\$index].isFailed ? 'fail' : 'ok', {'regular': \$ctrl.phaseType === \$ctrl.healthCheckPhase.CLOSE_COUNTERS}]"
  ng-if="!\$ctrl.hideOk || \$ctrl.statuses[\$index].isFailed">
  <div class="hc-item-list">
    <h2>
      {{ listName }}
      <span class="status--label" ng-class="\$ctrl.statuses[\$index].isFailed ? 'status--danger' : 'status--success'">
        {{ \$ctrl.statuses[\$index].isFailed ? 'Failed' : 'Success' }}
      </span>
    </h2>
    <div class="hc-item-wrapper">
      <general-health-check ng-if="\$ctrl.phaseType === \$ctrl.healthCheckPhase.HEALTH_CHECK" checks="checkList" hide-ok="\$ctrl.hideOk"></general-health-check>
      <close-counters-health-check ng-if="\$ctrl.phaseType === \$ctrl.healthCheckPhase.CLOSE_COUNTERS" checks="checkList"></close-counters-health-check>
    </div>
  </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/health-check-list/health-check-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;